<template>
  <ul class="step-circles">
    <li class="step-circles--item" :class="{'selected': step == 1, 'completed': step > 1}">
      <span>1</span>
    </li>
    <li class="step-circles--item" :class="{'selected': step == 2, 'completed': step > 2}">
      <span>2</span>
    </li>
    <li class="step-circles--item" :class="{'selected': step == 3, 'completed': step > 3}">
      <span>3</span>
    </li>
    <li class="step-circles--item" :class="{'selected': step == 4, 'completed': step > 4}">
      <span>4</span>
    </li>
    <li class="step-circles--item" :class="{'selected': step == 5, 'completed': step > 5}">
      <span>5</span>
    </li>
  </ul>
</template>
<script>
  export default {
    name: 'step-circles',
    props: ['step'],
    data(){
      return {
      }
    },
    methods: {
    },
    mounted() {

    }
  };
</script>